import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const EditableTitle = ({ title, onEdit, onSave, onChange, itemType }) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(title);

  useEffect(() => {
    setInputValue(title);
  }, [title]);

  const handleSave = () => {
    if (inputValue.trim() === "") {
      setIsEditing(true);
      return;
    }
    onSave(inputValue);
    setIsEditing(false);
  };

  const handleDoubleClick = () => {
    setIsEditing(true);
    onEdit();
  };

  return (
    <div
      onDoubleClick={handleDoubleClick}
      style={{ fontSize: "16px", cursor: "pointer" }}
      title={t("double_click_to_edit")} // Ajout d'un tooltip pour indiquer l'action
    >
      {isEditing ? (
        <input
          type="text"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            onChange(e);
          }}
          onBlur={handleSave}
          onKeyPress={(e) => e.key === "Enter" && handleSave()}
          autoFocus
        />
      ) : (
        <span className={itemType === "section" ? "fw-bold" : ""}>{title}</span>
      )}
    </div>
  );
};

export default EditableTitle;
